const user = 'user@test.com'
const verified_user = 'verified_user@test.com'
const organization = 'organization@test.com'
const superadmin = 'superadmin@test.com'
const organization1 = 'zaimnasution@test.com'
const password = '123456'

const auth = () => {
  const check = (form) => {
    return new Promise((resolve, reject) => {
      if(
        (form.email === organization || form.email === organization1)
        && form.password === password
      ){
        console.log('logged in as organization')
        resolve({
          status: 200,
          email: form.email,
          token: 'organization_dummy_token',
          role: 'organization'
        })
      }
      else if (
        form.email === verified_user
        && form.password === password
      ){
        console.log('logged in as verified_user')
        resolve({
          status: 200,
          email: form.email,
          token: 'verified_user_dummy_token',
          role: 'verified_user'
        })
      }
      else if (
        form.email === user
        && form.password === password
      ){
        console.log('logged in as user')
        resolve({
          status: 200,
          email: form.email,
          token: 'user_dummy_token',
          role: 'user'
        })
      }
      else if (
        form.email === superadmin
        && form.password === password
      ){
        console.log('logged in as superadmin')
        resolve({
          status: 200,
          email: form.email,
          token: 'superadmin_dummy_token',
          role: 'superadmin'
        })
      }
      else {
        reject({
          status: 404,
          message: 'Email/password is wrong.'
        })
      }
    })
  }

  const login = (data) => {
    localStorage.setItem('khub_data', JSON.stringify(data))
  }

  const logout = () => {
    localStorage.removeItem('khub_data')
  }

  const getCurrentUser = () => {
    const data = localStorage.getItem('khub_data')
    return data ? JSON.parse(data) : {}
  }

  const isOfficial = getCurrentUser() ? getCurrentUser().role === 'organization' : false
  const isVerified = getCurrentUser() ? getCurrentUser().role === 'verified_user' : false
  const isUser = getCurrentUser() ? getCurrentUser().role === 'user' : false
  const isSuperadmin = getCurrentUser() ? getCurrentUser().role === 'superadmin' : false

  return {
    check,
    login,
    logout,
    getCurrentUser,
    isOfficial,
    isVerified,
    isUser,
    isSuperadmin,
  }
}

export default auth
